<template>
  <div class="container settings">
      <h4 class="title is-4">Innstillinger</h4>
      <b-switch v-model="checkbox">
                BETA: Benytt gammel rapportdatabase (denne endringen huskes kun for gjeldende nettleser på nåværende maskin)
      </b-switch>
  </div>
</template>

<script>
export default {
    data () {
        return {
            checkbox: localStorage.getItem('useOldReportStorage') || false
        }
    },
    watch: {
        checkbox: function () {
            // this.checkbox = !this.checkbox
            localStorage.setItem('useOldReportStorage', this.checkbox)
        }
    },
    methods: {
        changeReportStorage() {
            // this.checkbox = !this.checkbox
            localStorage.setItem('useOldReportStorage', this.checkbox)
        }
    }
}
</script>

<style lang="scss" scoped>
div.settings {
    margin-top: 32px;
}
</style>